import React, { forwardRef, HTMLAttributes } from "react";

interface CustomDivProps extends HTMLAttributes<HTMLElement> {
  children: React.ReactNode;
  className?: string;
}

const CommonLayout = forwardRef<HTMLElement, CustomDivProps>(({
  children,
  className,
  ...props
}, ref) => {
  const hasPx = className?.split(" ").some((cls) => cls.startsWith("px-"));
  const classNameModify = `${
    hasPx ? "" : "px-4"
  } max-w-[1400px] mx-auto ${className || ""}`.trim();
  return (
    <section ref={ref} className={`${classNameModify}`.trim()} {...props}>
      {children}
    </section>
  );
});

CommonLayout.displayName = 'CommonLayout';

export default CommonLayout;
